<script lang="jsx">
import BuyNow from './buy-now.vue';
import Edit from './edit.vue';
import EditDelta from './edit-delta.vue';
import Add from './add.vue';
import Trial2paid from './trial2paid.vue';
import planPropsMixin from '@/plans/mx/plan-props';

export default {
  mixins: [planPropsMixin],
  render() {
    if (this.$context.is.add2cart) return <Add {...this.$attrs} />;
    if (this.$context.is.edit) {
      if (this.$context.is.addQty) {
        return <EditDelta {...this.$attrs} />;
      } else {
        return <Edit {...this.$attrs} />;
      }
    }
    if (this.$context.is.buyNow || this.$context.is.basic2pro) return <BuyNow {...{ ...this.$props, ...this.$attrs }} />;
    if (this.$context.is.trial2paid) return <Trial2paid {...this.$attrs} />;
    return null;
  },
};
</script>
